export const vptSpecifcFields = {
    disconnectionOfRainwater: null,
    disconnectedSurface: null,
    propertyDelivered: null,
    dateOfPropertyDelivery: null,
    work1_sizingProblem: null,
    work1_commentSizingProblem: null,
    work1_stateOfRetentionStructure: null,
    work1_commentstateOfRetentionStructure: null,
    work1_missingDocuments: null,
    work1_commentMissingDocuments: null,
    work2_sizingProblem: null,
    work2_commentSizingProblem: null,
    work2_stateOfRetentionStructure: null,
    work2_commentstateOfRetentionStructure: null,
    work2_missingDocuments: null,
    work2_commentMissingDocuments: null,
    work3_sizingProblem: null,
    work3_commentSizingProblem: null,
    work3_stateOfRetentionStructure: null,
    work3_commentstateOfRetentionStructure: null,
    work3_missingDocuments: null,
    work3_commentMissingDocuments: null,
    work4_sizingProblem: null,
    work4_commentSizingProblem: null,
    work4_stateOfRetentionStructure: null,
    work4_commentstateOfRetentionStructure: null,
    work4_missingDocuments: null,
    work4_commentMissingDocuments: null,
    work5_sizingProblem: null,
    work5_commentSizingProblem: null,
    work5_stateOfRetentionStructure: null,
    work5_commentstateOfRetentionStructure: null,
    work5_missingDocuments: null,
    work5_commentMissingDocuments: null,
};
